<template>
  <div class="container">
    <div v-if="event" class="mb-4">
      <router-view></router-view>
    </div>

    <b-card-group deck v-if="event">
      <wishlist-component></wishlist-component>

      <b-card no-body class="shadow rounded">
        <img v-if="event.image" class="card-img-top" v-bind:src="event.image" v-bind:alt="event.name">
        <div class="card-body p-3">
          <h5 class="card-title mb-4">{{ event.name }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">
            <font-awesome-icon icon="calendar-alt" /> <span class="ml-2">{{ event.date }}</span>
          </h6>
        </div>
        <b-card-body class="p-3 border-top">
          <b-card-text class="my-2">
            <vue-markdown :source="event.description"></vue-markdown>
          </b-card-text>
        </b-card-body>
      </b-card>
    </b-card-group>

    <b-card bg-variant="danger" text-variant="white" class="not-found text-center" v-if="!event">
      <b-card-img src="/img/icons/mstile-150x150.png"></b-card-img>
      <b-card-text>
        <b-spinner variant="white" type="grow" label="Loading"></b-spinner>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apiUrl } from '@/config'
import WishlistComponent from '@/components/WishlistComponent'

export default {
  computed: mapState({
    event: state => state.events.event,
  }),
  data: () => {
    return { apiUrl: apiUrl }
  },
  created () {
    this.$store.dispatch('events/getEvent', this.$route.params.event)
  },
  components: {
    WishlistComponent,
  }
}
</script>

<style lang="scss" scoped>
  $card-width: 16em;

  .card-deck {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(17rem, 1fr));
    grid-gap: .5rem;

    .card {
      &.rounded {
        border-radius: 0.5rem !important;
      }
    }
  }

  .not-found {
    margin: 0 auto;
    width: $card-width;
  }
</style>
